import { render } from "./PlatFormShop.vue?vue&type=template&id=e637c962&scoped=true"
import script from "./PlatFormShop.vue?vue&type=script&lang=js"
export * from "./PlatFormShop.vue?vue&type=script&lang=js"

import "./PlatFormShop.vue?vue&type=style&index=0&id=e637c962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e637c962"]])

export default __exports__